import DonutChart from '../common/donut/donutChart';
import { SubHeading } from '../common/subHeading';

export const TopSectors = ({ sectors }) => (
  <div className="lil-mt-20">
    <SubHeading title="Top Sectors" />
    <DonutChart data={sectors} />
  </div>
);



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/topSectors.tsx